import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

// based on https://icons.app.sbb.ch/kom/chevron-right-small.svg
export const ChevronRight: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <polyline fill="none" stroke={iconColor} points="8 4 16 12 8 20" />
    </svg>
  );
};
